exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/app/shared/forgotPassword/forgotPasswordModal.component.scss
// module id = ../../../../../src/app/shared/forgotPassword/forgotPasswordModal.component.scss
// module chunks = main